import { Immutable } from "immer";
import React from "react";
import { RawHTMLBlock } from "tsi-common-react/src/components/RawHTMLBlock/index";
import { t } from "ttag";

import type { CompareHeroBlock as CompareHeroBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { HighlightBar } from "../HighlightBarBlock";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: CompareHeroBlockValue }>;
type MobileBannerBlock = NonNullable<
    NonNullable<IProps["value"]["promo_badge"]>["mobile_banner_copy"]
>[number];

const MobileBannerCopyBlock = (
    props: Immutable<{ block: MobileBannerBlock }>,
): React.JSX.Element => {
    const wrapperClassName = `w-block-${props.block.type} block-${props.block.type}`;

    if (props.block.type === "html_block") {
        return (
            <div className={wrapperClassName}>
                <RawHTMLBlock value={props.block.value} />
            </div>
        );
    }

    return (
        <div className={wrapperClassName}>
            <div dangerouslySetInnerHTML={{ __html: props.block.value }} />
        </div>
    );
};

export const CompareHeroBlock = (props: IProps): React.JSX.Element => {
    const value = props.value;
    const promoBadge = value.promo_badge;
    const mobileBannerCopy = promoBadge?.mobile_banner_copy ?? [];

    return (
        <>
            <section
                className={styles.compareHeroC}
                style={{
                    backgroundImage: `url("${value.image?.url ?? ""}")`,
                    backgroundPosition: "40% 27px",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className={styles.compareHeroCMainContainer}>
                    <h1 className={styles.compareHeroCTitle}>{value.copy}</h1>
                    <p></p>
                    <img
                        className={concatClassNames([
                            styles.heroBadge,
                            `hero-badge__${promoBadge?.position ?? ""}`,
                        ])}
                        src={promoBadge?.image.url ?? ""}
                        alt={t`Casper by Sealy Promotion`}
                    />
                    <div>
                        <a
                            className={concatClassNames([
                                styles.compareHeroCBuyButton,
                                "button",
                            ])}
                            href={value.button?.link?.url ?? ""}
                        >
                            {value.button?.cta_text}
                        </a>
                    </div>
                </div>
            </section>

            {mobileBannerCopy.length > 0 && (
                <HighlightBar
                    className={styles.highlightBarBlockCompareMobileBanner}
                >
                    <div className="content">
                        {mobileBannerCopy.map((block) => (
                            <MobileBannerCopyBlock
                                key={block.id}
                                block={block}
                            />
                        ))}
                    </div>
                </HighlightBar>
            )}
        </>
    );
};
